/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneAllCases';
const QS_TYPE: QueryStateSchema['type'] = 'allCases';

export const useOpenAllCasesPane = (): ((args: { allCases: string }) => void) => {
  const [allCasesDeprecated, setAllCases] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (allCasesDeprecated) {
      setAllCases(null);
      setState(backwardsCompatabilityFactory({ id: allCasesDeprecated, type: QS_TYPE }));
    }
  }, [allCasesDeprecated]);

  return ({ allCases }) => {
    setState(prevState => [...(prevState || []), {
      id: allCases,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
